export default [
  {
    path: '/partner-jobs-booking',
    name: 'partner-jobs-booking',
    component: () => import('@/views/modules/partner-jobs/booking'),
    meta: {
      requiresAuth: true,
      title:'Job Booking',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Booking' }
      ]
    },
    
  }, 

  {
    path: '/partner-jobs-enquiry',
    name: 'partner-jobs-enquiry',
    component: () => import('@/views/modules/partner-jobs/enquiry'),
    meta: {
      requiresAuth: true,
      title:'Jobs Enquiry',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Job Enquiry' }
      ]
    },
    children:[
      {
        path: '/partner-jobs-enquiry/:id/detailed',
        name: 'partner-jobs-enquiry-detailed',
        props: true,
        component: () => import('@/views/modules/partner-jobs/enquiryDetailed'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Job Detailed',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Jobs Enquiry', link: '/partner-jobs-enquiry' },
            { text: 'Detailed' }
          ]
        }
      },
    ]
    
  }, 

]